import React, { useEffect } from "react";
import { FallbackProps } from "react-error-boundary";
import { Box, Typography, Button, Container } from "@mui/material";
import * as Sentry from "@sentry/react";

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  useEffect(() => {
    // Only report to Sentry in production
    if (process.env.REACT_APP_ENV === "production") {
      Sentry.captureException(error);
    } else {
      console.error(
        "Error caught by boundary (not reported to Sentry in dev):",
        error
      );
    }
  }, [error]);

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        textAlign="center"
        p={4}
        borderRadius={2}
        boxShadow={3}
        bgcolor="background.paper"
      >
        <Typography variant="h5" color="error" gutterBottom>
          Something went wrong.
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {error.message}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={resetErrorBoundary}
          sx={{ mt: 2 }}
        >
          Reload Page
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorFallback;
